import styled from "styled-components";
import { Flex, GridContainer } from "../../common/Layouts/styles";
import { fadingTextColor, secondaryColor } from "../../styles/styles";
import { Logo } from "../Header/styles";

export const Container = styled("div")`
  /* padding: 0 2vw; */

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 2vw 0;
  }
`;

export const ContactGrid = styled(GridContainer)`
  gap: 1vw;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 2vw 0;
  }
`;

export const Card = styled(Flex)`
  background: ${secondaryColor};
  padding: 1.6vw;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 3.6vw;
  }
`;

export const CardTitle = styled("h2")`
  font-size: 3vw;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 9vw;
  }
`;

export const Text = styled("span")`
  color: ${fadingTextColor};
  margin-top: ${(props: { marginTop?: string }) => props.marginTop || 0};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 4vw;
  }
`;

export const ContactInfoTop = styled(Flex)`
  flex-direction: column;
  margin-top: 1rem;
`;

export const ContactInfoBottom = styled(Flex)`
  margin-bottom: 2.4em;
  /* align-self: flex-start; */
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    margin-top: 8vw;
  }
`;

export const ContactWrapper = styled(Flex)`
  flex-direction: column;
  align-self: flex-start;
  padding-top: 1.6rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    margin-bottom: 6vw;
  }
`;

export const Contact = styled(Flex)`
  gap: 1.5rem;
  margin-bottom: 1rem;
`;

export const ContactDetails = styled(Flex)`
  flex-direction: column;
  width: 100%;
  align-self: flex-start;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    gap: 2vw;
  }
`;

export const ContactImage = styled("img")`
  min-width: 4.8vw;
  max-width: 4.8vw;
  min-height: 4.8vw;
  max-height: 4.8vw;
  object-fit: cover;
  border-radius: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    min-width: 20vw;
    max-width: 20vw;
    min-height: 20vw;
    max-height: 20vw;
  }
`;

export const ContactName = styled("h4")`
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 5em;
  }
`;

export const CompanyName = styled(Logo)`
  font-size: 2em;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 6em;
  }
`;
